<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Labeltype') : $t('New Labeltype')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.costs"
              type="number"
              :label="$t('Costs')"
              v-validate="'required'"
              required
              data-vv-name="costs"
              :error-messages="errors.collect('costs')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.monitoring_contract"
              :label="$t('Monitoring Contract')"
              v-validate="'required'"
              required
              data-vv-name="monitoring_contract"
              :error-messages="errors.collect('monitoring_contract')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.registration_number"
              :label="$t('Registration Number')"
              v-validate="'required'"
              required
              data-vv-name="registration_number"
              :error-messages="errors.collect('registration_number')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.homologation_name"
              :label="$t('homologation_name')"
              v-validate=""
              data-vv-name="homologation_name"
              :error-messages="errors.collect('homologation_name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.stock_min"
              type="number"
              :label="$t('Min stock quantity')"
              v-validate="'required'"
              required
              data-vv-name="stock_min"
              :error-messages="errors.collect('stock_min')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.default_order_quantity"
              type="number"
              :label="$t('Default order quantity')"
              v-validate="'required'"
              required
              data-vv-name="default_order_quantity"
              :error-messages="errors.collect('default_order_quantity')"
            ></v-text-field>
            <v-select
              v-model="formValues.company_id"
              :items="companies"
              label="Firma"
              item-text="name"
              item-value="id"
            ></v-select>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'labelType.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, fetchCompanies } from "../shared/services";
export default {
  name: "app-labelType-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      loading: true,
      door_types: [],
      companies: []
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
    if (this.$auth.check("customer.editall")) {
      fetchCompanies({ page: 1, itemsPerPage: "-1" }).then(res => {
        this.companies = res.data;
      });
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "labelType.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
